import { ProductBadges } from '../../components/badges/ProductBadges';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '../../utility/Utils';
import { Badge } from 'reactstrap';

export const ContactList = [
  {
    name: 'Correo del Lead',
    selector: 'buyer',
    sortable: true,
    searchable: true,
    width: '20%',
    cell: (row) => row?.buyer?.email || '',
  },
  {
    name: 'Estado',
    selector: 'paid',
    sortable: true,
    searchable: true,
    width: '12.5%',
    cell: (row) => <Badge color="secondary">Oportunidad</Badge>,
  },
  {
    name: 'Fecha de Creación',
    selector: 'create_at',
    sortable: true,
    searchable: true,
    width: '12.5%',
    cell: (row) => {
      return (
        <div className="w-100">
          {formatDate(row?.create_at, {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
        </div>
      );
    },
  },

  {
    name: 'Productos',
    sortable: true,
    searchable: true,
    width: '50%',
    cell: (row) => {
      return (
        <div className="d-flex">
          {row?.saleProducts?.map((saleProduct) => (
            <ProductBadges
              text={saleProduct.name}
              status={saleProduct.status}
            />
          ))}
        </div>
      );
    },
  },
];
